import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-securite-donnees',
  templateUrl: './securite-donnees.component.html',
  styleUrls: ['./securite-donnees.component.scss']
})
export class SecuriteDonneesComponent implements OnInit {

  constructor(
    // public meta: Meta, 
    // public title: Title
  ) { }

  ngOnInit() {
    // this.meta.updateTag({ name: 'description', content: "" }); 
    // this.meta.updateTag({ name: 'keywords', content: ""})
  }

}
